import { BaseParameterDto } from '../../../_models/base-parameter-dto';

export class UserCommunitiesParametersDto extends BaseParameterDto {
    userId: string;
    includeInactive: boolean;
    locationIds: number[];
    communityIds: number[];
}
